import React from "react";
import AboutImg from '../../assets/about.webp';
import AboutImg2 from '../../assets/about-2.webp';
import AboutIcon1 from '../../assets/at_icon1.webp';
import AboutIcon2 from '../../assets/at_icon2.webp';
import AboutIcon3 from '../../assets/at_icon3.webp';

const AboutUs =()=>{

    return(<>
          <section className="about_section-1">
          <div className="container">
            <div className="row justify-content-around align-items-center">
                    <div className="col-md-5">
                    <div className="about_image">
                    <img src={AboutImg} className='img-fluid' alt='About Company' loading="lazy"/>
                    </div>
                    </div>

                    <div className="col-md-5">
                    <div className="section-title mb-2 text-left">
                       <p>- About Company -</p>
                       <h1 className="h1_title">Work With Reliable On Road <br/>Truck Repair Services</h1>
                    </div>
                    <div className="about_content text-left">
                    <p className="mb-1">
                    We specialize in assisting you in locating the most reliable Truck Repair
                    Services and truck and trailer repair near you —quickly. Our sophisticated
                    search software is programmed to provide precise, real-time information on
                    local repair shops within seconds, along with the shortest path to get there.
                    Whether you're experiencing a breakdown, require truck tire repair or
                    routine <a href="https://breakdowninc.net/contact">truck maintenance</a>, we've got you covered.
                    </p>
                    <p className="mb-1">
                    From reefer repair to RVs and commercial trailers and trucks, our website brings
                    you in touch with the top service providers in the nation. If you're looking for
                    a truck tire shop or require reefer repair or tow help immediately, our network
                    is just a few clicks away.
                    </p>
                    <p className="mb-0">
                    In addition, our professional customer support is also there to assist you 24/7/365
                    in utilizing our app or getting trusted truck and trailer repair near you services—anywhere, anytime.
                    </p>

                    </div>
                    </div>

         </div>
         </div>
        </section>

        <section className="about_section-3">
          <div className="container">
             <div className="row justify-content-center align-items-center">

              <div className="col-md-12">
              <div className="section-title mb-md-5 mb-2 pb-md-3 pb-2">
                  <p>- Prominent Service Providers -</p>
                  <h2>Promote Your Business with BreakdownInc</h2>
              </div>
              </div>

              <div className="col-md-6 pr-md-5">
                <div className="about_highlights mb-md-5 mb-4">
                  <span className="about_icon">
                    <img src={AboutIcon1} className='img-fluid' alt='Swift Access' loading="lazy"/>
                  </span>
                  <h3>Swift Access</h3>
                  <p>Fleet managers and drivers demand swift and reliable access to service vendors nationwide.
                    Our platform ensures your business is readily discoverable when services are
                    needed in your region.
                  </p>
                </div>

                <div className="about_highlights mb-md-5 mb-4">
                  <span className="about_icon">
                    <img src={AboutIcon2} className='img-fluid' alt='Broad Audience' loading="lazy"/>
                  </span>
                  <h3>Broad Audience</h3>
                  <p>With thousands of fleet managers and truck drivers relying on the Breakdown Inc website and apps daily,
                    your business will connect with a vast network. This brings a continuous stream of new and repeat customers.
                  </p>
                </div>

                <div className="about_highlights">
                  <span className="about_icon">
                    <img src={AboutIcon3} className='img-fluid' alt='Measurable Impact' loading="lazy"/>
                  </span>
                  <h3>Measurable Impact</h3>
                  <p>Our detailed analytics on numerous listings annually show significant business growth for our vendors.
                    While success varies by location and services offered, vendors typically experience a return on
                    investment exceeding ten times their initial cost. Partner with us and see your business flourish!
                  </p>
                </div>

              </div>

              <div className="col-md-6">
                <div className="about_screenshots">
                <img src={AboutImg2} className='img-fluid' alt='Advertisement Flow' loading="lazy"/>
                </div>
              </div>

             </div>
          </div>
        </section>

        </>
    );
};

export default AboutUs;